module.exports = __webpack_public_path__ + "article-7051a3ee/schlusssatz-bewerbung-8505c660210e539788c0d64dfa2bf2a4.jpg";